export default "__VITE_ASSET__D$c2iOdH__"